import { GsapModel } from "@api/types/gsap";
import { httpClient } from "../../httpClient";

type Data = any;

export async function getGsap(): Promise<any> {
  try {
    const { data } = await httpClient.get(`/api/v1/gsap/`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getGsapById(id: number): Promise<any> {
  try {
    const { data } = await httpClient.get(`/api/v1/gsap/${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postGsap(payload: GsapModel): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(`/api/v1/gsap/`, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putGsap(id: number, payload: GsapModel): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(`/api/v1/gsap/${id}`, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const gsap = {
  getGsap,
  getGsapById,
  postGsap,
  putGsap,
};
